//创建Vuex中的核心  store

//引入Vue
import Vue from "vue";
//引入Vuex
import Vuex from 'vuex'


const actions = {//组件中的动作
}
const mutations = {//用于操作数据（state）
    openAddModel(state,payload){
        state.openAddModel = true;
        state.modelType =payload.modelType;
        state.modelImages = payload.modelImages;
    },
    closeAddModel(state){
        state.openAddModel = false;
    },
    /**
     * 跳转页面
     * @param state
     * @param value 页面：/home 、 /navigation
     */
    toPage(state,value){
        console.log('topage中的数据-----',state,value)
        if(value){
            state.currentPage = value;
        }
    },
    setModelType(state,value){
        if (value){
            state.modelType = value;
        }
    },
    setPageTitle(state,value){
        if (value){
            state.pageTitle = value;
        }
    }
}
const state = {//用于存储数据
    currentPage:'/home',
    modelType:'横梁自立式 WFT',
    pageTitle:'产品查询',
    modelImages:'',
    openAddModel:false,

}
const getters ={//用于获取加工后的数据

}

Vue.use(Vuex)

export default new Vuex.Store({
    actions,
    mutations,
    state,
    getters
})

